export const imagePaths = {
    publicidad: `${process.env.PUBLIC_URL}/Enfiestandonos/publish/gasca.png`,
    publicidad1: `${process.env.PUBLIC_URL}/Enfiestandonos/publish/fuentesgasca.png`,
   
  };